import React, { useEffect, useState } from "react";
import { FastField, Field, useFormikContext } from "formik";
import {
  Button,
  Col,
  FormGroup,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap";
import styles from "./Resource.module.scss";
import ReactSelect from "../common/Form/ReactSelect";
import { OnlyNumberAllow, OnlyNumberLength } from "../../helpers";
import DatePickerField from "../common/Form/DatePicker";
import { useSelector } from "react-redux";
import MultiSelect from "../common/Form/Multiselect";
import PhoneInputNumber from "../common/Form/MobileInput";
import { FiInfo } from "react-icons/fi";

function ResourceInfo() {
  const { errors, touched,values } = useFormikContext();
  const [departmentOption, setDepartmentOption] = useState([])
  const [skillsOption, setSkillsOption] = useState([])
  const [designationOption, setDesignationOption] = useState([])
  const [selectedDesignation, setselectedDesignation] = useState(null)
  const departmentment = useSelector((state) => state.masterData.department);
  const skills = useSelector((state) => state.masterData.skills);
  const designation = useSelector((state) => state.masterData.designation)
  useEffect(() => {
    if (departmentment && departmentment.length > 0) {
      const resVal = departmentment.map((val) => {
        return {
          id: val?.id,
          value: val?.name,
          label: val?.name,
        };
      });
      setDepartmentOption(resVal);
    }
  }, [departmentment]);

  useEffect(() => {
    if (skills && skills.length > 0) {
      const resVal = skills.map((val) => {
        return {
          id: val?.id,
          value: val?.name,
          label: val?.name,
        };
      });
      setSkillsOption(resVal);
    }
  }, [skills]);

  useEffect(() => {
    if (designation && designation.length > 0) {
      const resVal = designation.map((val) => {
        return {
          id: val?.id,
          value: val?.name,
          label: val?.name,
        };
      });
      setDesignationOption(resVal);
      setselectedDesignation(null)
    }else{
      setDesignationOption([]);
      setselectedDesignation(null)

    }
  }, [designation]);


  return (
    <div>
      <Row>
        <Col md="6" xs="12">
          <FormGroup className="form-group">
            <Label className={styles.formLabel}>First Name</Label>
            <Field maxlength="15" name="name" id="name" className="form-control" />
            {errors.name || touched.name ? (
              <div className={styles.formError}>{errors.name}</div>
            ) : null}
          </FormGroup>
        </Col>
        <Col md="6" xs="12">
          <FormGroup className="form-group">
            <Label className={styles.formLabel}>Last Name</Label>
            <Field maxlength="15" name="lastname" id="lastname" className="form-control" />
            {errors.lastname || touched.lastname ? (
                <div className={styles.formError}>{errors.lastname}</div>
            ) : null}
          </FormGroup>
        </Col>
      </Row>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Department</Label>
        <Field
          name="department"
          id="department"
          placeholder="Select Department"
          isMulti={false}
          component={ReactSelect}
          options={departmentOption}
          autocomplete="off"
        />
        {errors.department || touched.department ? (
          <div className={styles.formError}>{errors.department}</div>
        ) : null}
      </FormGroup>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Designation</Label>
        <Field
          name="designation"
          id="designation"
          placeholder="Select Designation"
          isMulti={false}
          component={ReactSelect}
          options={designationOption}
          selectedDesignation={selectedDesignation}
          setselectedDesignation={setselectedDesignation}
          autocomplete="off"
        />
        {errors.designation || touched.designation ? (
          <div className={styles.formError}>{errors.designation}</div>
        ) : null}
      </FormGroup>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Phone</Label>
        {/* <Field
          className="form-control"
          onKeyPress={(event) => {
            OnlyNumberAllow(event);
          }}
          name="phone"
          type="text"
        /> */}
        <PhoneInputNumber name="phone" autocomplete="off" />
        {errors.phone || touched.phone ? (
          <div className={styles.formError}>{errors.phone}</div>
        ) : null}
      </FormGroup>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Experience</Label>
        <Row>
          <Col md={6}>
            {/* <Label className={styles.formLabel}>Year</Label> */}
            <Field
              className="form-control"
              onKeyPress={(event) => {
                OnlyNumberLength(event);
              }}
              maxlength="2"
              name="experienceYear"
              placeholder="Year"
              autocomplete="off"
            />
          </Col>
          <Col md={6}>
            {/* <Label className={styles.formLabel}>Month</Label> */}
            <Field className="form-control" name="experienceMonth" as="select">
              <option value="" className="disableOption" selected disabled>Month</option>
              {Array.from(Array(12), (e, i) => {
                return <option value={i}>{i}</option>;
              })}
            </Field>
          </Col>
        </Row>
      </FormGroup>
      <FormGroup className="form-group">
        <Row>
          <Col md={6}>
            <Label className={styles.formLabel}>Date of Joining</Label>
            <DatePickerField
              className="form-control"
              name="dateOfJoining"
              autoComplete="off"
            />
          </Col>
          <Col md={6}>
            <Label className={styles.formLabel}>Date of Birth <FiInfo className="infoIcon" title="Minimum age must be 18 years" /></Label>
            <DatePickerField
              className="form-control"
              name="dob"
              autoComplete="off"
              maxDate={new Date()}
            />
          </Col>
        </Row>
      </FormGroup>
      <FormGroup className="form-group">
        <Label className={styles.formLabel}>Skills</Label>
        <Field
          name="skills"
          id="skills"
          placeholder="Select Skills"
          isMulti={true}
          component={MultiSelect}
          options={skillsOption}
        />
      </FormGroup>
    </div>
  );
}

export default ResourceInfo;
